const createSafeStorage = (getStorage: () => Storage) => ({
  getItem: (key: string) => {
    try {
      return getStorage().getItem(key);
    } catch {
      return null;
    }
  },
  removeItem: (key: string) => {
    try {
      getStorage().removeItem(key);
      return true;
    } catch {
      return false;
    }
  },
  setItem: (key: string, value: string) => {
    try {
      getStorage().setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
});

const safeLocalStorage = createSafeStorage(() => window.localStorage);
const safeSessionStorage = createSafeStorage(() => window.sessionStorage);

export { safeLocalStorage, safeSessionStorage };
